<template>
  <splitpanes class="default-theme">
    <pane min-size="15" size="20">
      <div class="card-header" style="width: 100%;border: solid 1px lightgrey">
        <span style="margin: 5px;font-weight: bold">内训目录</span>
        <el-icon :size="24" @click="refreshNode(currentDir.id)" style="margin-top: 5px">
          <ElIconRefresh class="el-icon-refresh"/>
        </el-icon>
      </div>

      <el-tree
          class="mytree"
          ref="tree"
          :data="dirData"
          :props="defaultProps"
          node-key="id"
          :load="loadNode"
          lazy
          @node-click="nodeClickHandle"
          highlight-current
          :expand-on-click-node="false"
          min-height="500px"
          style="height: 100%;overflow: auto"
      >
      </el-tree>
    </pane>
  </splitpanes>
</template>

<script>
import {Pane, Splitpanes} from "splitpanes";
import 'splitpanes/dist/splitpanes.css'

export default {
  name: "CatalogManage",
  components: {Splitpanes, Pane},
  provide() {
    return {
      $fn: {

      }
    }
  },
  computed: {

  },
  data() {
    return {
      dirData: [],
      currentDir: {},
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf',
      },
      loading: false,
    }
  },
  methods: {

    refreshNode(nodeId){
      if(nodeId && nodeId.length > 0){
        this.$refs.tree.store.nodesMap[this.currentDir.id].loaded = false;
        this.$refs.tree.store.nodesMap[this.currentDir.id].loadData();
      }else{
        this.loadDirTree()
      }
    },
    //--勾选--
    nodeClickHandle(currentRow) {
      this.currentDir = currentRow
      this.currentPage = 1
      this.$refs.frameQuery.search();
    },

    async loadDirTree() {
      let data = await this.$http('sysDirService.getChildren', {dir_def_id: 'inner_train', parent_id: ''})
      this.dirData = data;
    },

    async loadNode(node, resolve) {
      console.log("node.id=" + node.data.id);
      let data = await this.$http('sysDirService.getChildren', {dir_def_id: 'inner_train', parent_id: node.data.id})
      resolve(data)
    }

  },
  created() {
  }
}
</script>

<style lang="less" scoped>
@import 'src/global';

.card-header {
  display: inline-flex;
  height: 36px;
}

.department-name {
  font-size: @fontSizeX;
}

.myContainer {
  padding: 5px;
}

.el-tree{
  padding-top: 10px;
  min-height: 600px;
}

.mytree {
  margin-left: -15px;

  :deep(.el-tree-node__content) {
    padding: 0 !important;
  }

  :deep(.el-tree-node) {
    position: relative;
    padding-left: 16px;
  }

  :deep(.el-tree-node__children) {
    padding-left: 16px;
  }

  // 竖线
  :deep(.el-tree-node::before) {
    content: "";
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #b8b9bb;
  }

  :deep(.el-tree-node:last-child::before) {
    height: 38px;
  }

  // 横线
  :deep(.el-tree-node::after) {
    content: "";
    width: 20px;
    height: 20px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #b8b9bb;
  }

  :deep(& > .el-tree-node::after) {
    border-top: none;
  }

  :deep(& > .el-tree-node::before) {
    border-left: none;
  }

  :deep(.el-tree-node__expand-icon) {
    font-size: 16px;
  }

  :deep(.el-tree-node__expand-icon.is-leaf) {
    visibility: visible !important;
  }

  //:deep(.is-leaf) {
  //  //display: none; // 也可以去掉
  //  position: relative;
  //}

  :deep(.is-leaf)::before {
    content: ''; /* 必须有 content 属性 */
    position: absolute;
    top: 13.5px; /* 将横线定位在元素的中间 */
    left: 0;
    width: 100%;
    border-top: 1px dashed #b8b9bb; /* 虚线 */
    transform: translateY(-50%); /* 微调位置使其完全居中 */
  }
}

</style>